import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CommonResponse, ControlAccount } from "../interfaces/home";

@Injectable({
  providedIn: "root",
})
export class ControlAccountService {
  constructor(private http: HttpClient) {}
  baseUrl = environment.baseUrl + "ControlAccount/";
  // fetch all branch in the database
  allControlAccounts(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  allIncomeControlAccounts(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(
      this.baseUrl + "GetIncomeControlAccounts"
    );
  }
  getControlAccount(id: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }
  getControlAccountByName(name: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + "name/" + name);
  }
  postControlAccount(data: any) {
    return this.http.post(this.baseUrl, data);
  }
  deleteControlAccount(id: any) {
    return this.http.delete(this.baseUrl + id);
  }
  updateControlAccount(id: any, data: any) {
    return this.http.put(this.baseUrl + id, data);
  }
  GetAllByAccountClassCaption(
    accounClassCaption: string
  ): Observable<CommonResponse<ControlAccount[]>> {
    return this.http.get<CommonResponse<ControlAccount[]>>(
      this.baseUrl + "GetAllByAccountClassCaption/" + accounClassCaption
    );
  }
}
